/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FcbRemplacementDto,
  FcbRemplacementGridDtoPaginatedResults,
  FilterCriteriaInfo,
  RemplacementSearch,
  SelectItem,
} from '../models/index';
import {
    FcbRemplacementDtoFromJSON,
    FcbRemplacementDtoToJSON,
    FcbRemplacementGridDtoPaginatedResultsFromJSON,
    FcbRemplacementGridDtoPaginatedResultsToJSON,
    FilterCriteriaInfoFromJSON,
    FilterCriteriaInfoToJSON,
    RemplacementSearchFromJSON,
    RemplacementSearchToJSON,
    SelectItemFromJSON,
    SelectItemToJSON,
} from '../models/index';

export interface FormateurRemplacementBaseSearchRequest {
    RemplacementSearch?: RemplacementSearch;
}

export interface FormateurRemplacementDeleteRequest {
    id?: number;
}

export interface FormateurRemplacementGetRequest {
    id?: number;
}

export interface FormateurRemplacementGetSearchCriteriasRequest {
    includeListsValues?: boolean;
}

export interface FormateurRemplacementGetSelectItemsRequest {
    searchField: string;
}

export interface FormateurRemplacementSaveRequest {
    FcbRemplacementDto?: FcbRemplacementDto;
}

/**
 * 
 */
export class FormateurRemplacementApi extends runtime.BaseAPI {

    /**
     */
    async formateurRemplacementBaseSearchRaw(requestParameters: FormateurRemplacementBaseSearchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FcbRemplacementGridDtoPaginatedResults>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/FormateurRemplacement/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RemplacementSearchToJSON(requestParameters.RemplacementSearch),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FcbRemplacementGridDtoPaginatedResultsFromJSON(jsonValue));
    }

    /**
     */
    async formateurRemplacementBaseSearch(requestParameters: FormateurRemplacementBaseSearchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FcbRemplacementGridDtoPaginatedResults> {
        const response = await this.formateurRemplacementBaseSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async formateurRemplacementDeleteRaw(requestParameters: FormateurRemplacementDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/FormateurRemplacement`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async formateurRemplacementDelete(requestParameters: FormateurRemplacementDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.formateurRemplacementDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async formateurRemplacementGetRaw(requestParameters: FormateurRemplacementGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FcbRemplacementDto>> {
        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/FormateurRemplacement/get`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FcbRemplacementDtoFromJSON(jsonValue));
    }

    /**
     */
    async formateurRemplacementGet(requestParameters: FormateurRemplacementGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FcbRemplacementDto> {
        const response = await this.formateurRemplacementGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async formateurRemplacementGetSearchCriteriasRaw(requestParameters: FormateurRemplacementGetSearchCriteriasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FilterCriteriaInfo>>> {
        const queryParameters: any = {};

        if (requestParameters.includeListsValues !== undefined) {
            queryParameters['includeListsValues'] = requestParameters.includeListsValues;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/FormateurRemplacement/criterias`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FilterCriteriaInfoFromJSON));
    }

    /**
     */
    async formateurRemplacementGetSearchCriterias(requestParameters: FormateurRemplacementGetSearchCriteriasRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FilterCriteriaInfo>> {
        const response = await this.formateurRemplacementGetSearchCriteriasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async formateurRemplacementGetSelectItemsRaw(requestParameters: FormateurRemplacementGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SelectItem>>> {
        if (requestParameters.searchField === null || requestParameters.searchField === undefined) {
            throw new runtime.RequiredError('searchField','Required parameter requestParameters.searchField was null or undefined when calling formateurRemplacementGetSelectItems.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/FormateurRemplacement/criteriaList/{searchField}`.replace(`{${"searchField"}}`, encodeURIComponent(String(requestParameters.searchField))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SelectItemFromJSON));
    }

    /**
     */
    async formateurRemplacementGetSelectItems(requestParameters: FormateurRemplacementGetSelectItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SelectItem>> {
        const response = await this.formateurRemplacementGetSelectItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async formateurRemplacementSaveRaw(requestParameters: FormateurRemplacementSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FcbRemplacementDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://9692bd2b-c5bb-44ee-bb80-ed39776806fb/ReadAccess"]);
        }

        const response = await this.request({
            path: `/api/FormateurRemplacement/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FcbRemplacementDtoToJSON(requestParameters.FcbRemplacementDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FcbRemplacementDtoFromJSON(jsonValue));
    }

    /**
     */
    async formateurRemplacementSave(requestParameters: FormateurRemplacementSaveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FcbRemplacementDto> {
        const response = await this.formateurRemplacementSaveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
